<template>
  <div class="w-full min-w-[10rem] space-y-2 py-3 text-right">
    <span class="block min-w-max text-sm font-medium text-neutral-0">{{
      formatDate(new Date(template.updated), "d MMM HH:mm", {})
    }}</span>
    <span v-if="template.updated_by" class="block min-h-[1rem] text-sm font-medium text-neutral-0">{{
      template.updated_by
    }}</span>
  </div>
</template>
<script lang="ts" setup>
// Utils
import { formatDate } from "@helpers/formatters";

// Domain
import { TemplateItem } from "@domain/Templates";

//Props
withDefaults(
  defineProps<{
    template: TemplateItem;
  }>(),
  {},
);
</script>
